const currencies = ['USD', 'EUR', 'CHF', 'GBP'];

export default currencies;
